import { degreesToRadians } from "./utils";
export const SQRT_3 = Math.sqrt(3);
export const ATAN_15_DEG = Math.atan(degreesToRadians(15));
export const DEG_30_RADIANS = degreesToRadians(30);
export const DEG_36_RADIANS = degreesToRadians(36);
export const DEG_60_RADIANS = degreesToRadians(60);
export const DEG_72_RADIANS = degreesToRadians(72);
